import api from "../services/api";

const path = "funcionalidadepontoacesso";

export const getFunctionalitiesPointAccess = async () => {
  return await api.get(`${path}`);
};

export const findFunctionalityPointAccess = async ({ id }) => {
  return await api.get(`${path}/${id}`);
};

export const editFunctionalityPointAccess = async ({ id, body }) => {
  return await api.put(`${path}/${id}`, body);
};

export const createFunctionalityPointAccess = async ({ body }) => {
  return await api.post(`${path}`, body);
};

export const deleteFunctionalityPointAccess = async ({ id }) => {
  return await api.delete(`${path}/${id}`);
};
